module.exports = __webpack_public_path__ + "static/img/irole.65acaad.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/kc/irole.png
// module id = 3viB
// module chunks = 7